import { Box, Card, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { parseAVHtmlData } from "../../../utils/helpers";
import { ASSETS } from "../../../utils/config";
import RemoveIcon from "@mui/icons-material/Remove";
import { colors } from "../../../utils";
import ClearIcon from "@mui/icons-material/Clear";
import TextView from "../../TextView";
import RichTextEditorViewWheel from "../../Editor/children/RichTextEditorViewWheel";
import AddIcon from "@mui/icons-material/Add";
import ShareIcon from "@mui/icons-material/Share";

function SegmentContent({
  content,
  showLabels = true,
  onClose = () => {},
  onAddSegment = () => {},
  handleManageWheelSegment = () => {},
}) {
  const [fullPreview, setFullPreview] = useState(false);

  if (!content) {
    return null;
  }

  // const updatedHTML = parseAVHtmlData(content?.text_body);
  return (
    <>
      <Card
        sx={{
          //   my: 1,
          //   width: fullPreview ? "97vw" : "95vw",
          width: "380px",
          // height: fullPreview ? "95%" : "95vh",
          backgroundColor: content?.inner_color,
          p: 1.2,
          pt: 1,
          position: fullPreview ? "absolute" : "relative",
          top: fullPreview ? 100 : undefined, // Use undefined instead of false for CSS properties
          // overflow: fullPreview ? "hidden" : undefined,
          border: `1px solid ${content?.color}`,
          //   ml: "1.5vw",
          borderLeft: `10px solid ${content?.color}`,
          mb: 0.5,
          // scrollY: "auto",
          zIndex: fullPreview ? 1000 : undefined,
          // left: 18,
          // marginLeft: fullPreview ? undefined : "-1.7vw",
          alignSelf: "center",
        }}
      >
        <Stack
          sx={{ mb: 1 }}
          justifyContent={"space-between"}
          direction={"row"}
        >
          <Typography
            sx={{
              color: "#123051",
              fontFamily: "DM Sans",
              fontWeight: "bold",
              fontSize: "14px",
              textTransform: "capitalize",
            }}
          >
            {content?.title}
          </Typography>

          <Stack
            justifyContent={"space-between"}
            direction={"row"}
            alignItems={"center"}
          >
            <TextView
              onClick={handleManageWheelSegment}
              style={{
                fontSize: "12px",
                fontWeight: "600",
                marginRight: "5px",
                cursor: "pointer",
              }}
            >
              <img
                src={ASSETS.shareSegmentIcon}
                alt="shareSegmentIcon"
                width="16"
                height="16"
              />
            </TextView>

            <TextView
              onClick={() => onAddSegment(content)}
              style={{
                fontSize: "12px",
                fontWeight: "600",
                // color: "#0F52BA",
                marginRight: "5px",
                cursor: "pointer",
              }}
            >
              <AddIcon style={{ color: colors.darkGrey }} />
            </TextView>

            {fullPreview ? (
              <RemoveIcon
                onClick={() => setFullPreview(false)}
                size={10}
                style={{
                  fontSize: "25px",
                  color: colors.primary,
                  cursor: "pointer",
                }}
              />
            ) : (
              <img
                onClick={() => setFullPreview(true)}
                src={ASSETS.Content_Full_Preview}
                alt="preview"
                style={{ height: "16px", width: "16px", cursor: "pointer" }}
              />
            )}

            {/* <ClearIcon
              onClick={onClose}
              color={colors.primary}
              style={{
                fontSize: "28px",
                marginLeft: "5px",
                cursor: "pointer",
              }}
            /> */}
          </Stack>
        </Stack>

        <Stack sx={{ height: "100%" }} direction={"column"}>
          <Box
            sx={{
              width: "100%",
              height: "73vh",
              backgroundColor: "white",
              borderRadius: 2,
              pb: 1,
              // overflowY: "auto",
            }}
          >
            {/* <div
            style={{ lineHeight: 1, padding: 10 }}
            dangerouslySetInnerHTML={{ __html: updatedHTML }}
          /> */}
            <RichTextEditorViewWheel
              value={content?.text_body}
              id={content?.id}
            />
          </Box>
        </Stack>
      </Card>
    </>
  );
}

export default SegmentContent;
